import api from './api';

export const bugReportService = {
   getAll: ({ page = 1, limit = 15 } = {}) => api.get('/bug-reports', { params: { page, limit } }),
   updateStatus: (id, status) => api.patch(`/bug-reports/${id}/status`, { status }),
   delete: (id) => api.delete(`/bug-reports/${id}`),
};
